package com.example.mystybag.common.ui.theme

import androidx.compose.foundation.LocalIndication
import androidx.compose.foundation.gestures.detectTapGestures
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.LocalRippleConfiguration
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.SideEffect
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.platform.LocalFocusManager
import androidx.compose.ui.platform.LocalSoftwareKeyboardController
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.sp
import coil3.PlatformContext
import coil3.compose.setSingletonImageLoaderFactory
import com.arkivanov.decompose.extensions.compose.subscribeAsState
import com.example.mystybag.core.ui.theme.LocalTheme
import com.example.mystybag.core.views.AppTheme
import com.example.mystybag.core.views.AppThemeColors
import com.example.mystybag.core.views.currentTheme
import com.example.mystybag.core.views.isDarkTheme
import com.example.mystybag.common.extensions.AppThemeRippleConfig
import com.example.mystybag.common.extensions.CustomIndicationNodeFactory

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun AppThemeView(content: @Composable () -> Unit) {


    val isDark      = isDarkTheme.subscribeAsState()
    val currTheme   = remember(isDark.value) {
        AppThemeColors()
    }

    MaterialTheme(
        colorScheme = currTheme.colors,
        typography  = currTheme.typography.copy(bodyLarge = TextStyle( // delete copy of bodyLarge when compose fix DatePickerDialog colors!!!
            fontFamily      = LocalTheme.googleSans,
            fontWeight      = FontWeight.Normal,
            fontSize        = 16.sp,
            lineHeight      = 24.sp,
            letterSpacing   = 0.5.sp
        )
        ),
        content     = {
            CompositionLocalProvider(AppTheme provides currTheme) {
                CompositionLocalProvider(LocalRippleConfiguration provides AppThemeRippleConfig()) {
                    CompositionLocalProvider(LocalIndication provides CustomIndicationNodeFactory) {
                        setSingletonImageLoaderFactory { context ->
                            newImageLoader(context)
                        }
                        val focusManager = LocalFocusManager.current
                        val keyboardController = LocalSoftwareKeyboardController.current
                        Box(
                            modifier = Modifier
                                .fillMaxSize()
                                .pointerInput(Unit) {
                                    detectTapGestures {
                                        focusManager.clearFocus()
                                        keyboardController?.hide()
                                    }
                                }
                        ) {
                            content()
                        }
                    }
                }
            }
        }
    )

    SideEffect {
        currentTheme.value = currTheme
    }
}

@Composable
fun AppThemePreview(content: @Composable () -> Unit) {
    MaterialTheme(
        colorScheme = AppTheme.current.colors,
        typography  = AppTheme.current.typography,
        content     = content
    )
}